import { Box } from '@mui/material';

interface MultipleSelectionsProps {
  count?: number;
}

function MultipleSelections({ count = 0 }: MultipleSelectionsProps) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" py={10}>
      {count > 1 ? 'Multiple services selected' : 'Nothing selected.'}
    </Box>
  );
}

export default MultipleSelections;
